module.exports = __webpack_public_path__ + "static/img/Rectangle_808@2x.b341c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Rectangle_808@2x.png
// module id = 50eL
// module chunks = 59